"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Banner = _interopRequireDefault(require("../../Banner"));

var _Layout = require("../../Layout");

var _Hero = require("../Hero.style");

var HeroRegular = function HeroRegular(_ref) {
  var variant = _ref.variant,
      hero = _ref.hero,
      banner = _ref.banner,
      textColor = _ref.textColor,
      subTitle = _ref.subTitle,
      title = _ref.title,
      cta = _ref.cta,
      wrapperProps = _ref.wrapperProps;
  var defaults = {
    standard: {
      widths: 12
    },
    large: {
      widths: hero.heroLargeColumnWidth,
      background: 'none'
    }
  }[variant];

  if (wrapperProps.mediaType) {
    return /*#__PURE__*/_react.default.createElement(_Hero.MediaWrapper, Object.assign({
      variant: variant
    }, wrapperProps), /*#__PURE__*/_react.default.createElement(_Hero.Overlay, null, banner && /*#__PURE__*/_react.default.createElement(_Hero.HeroBanner, null, /*#__PURE__*/_react.default.createElement(_Banner.default, Object.assign({}, banner, {
      textColor: hero.bannerTextColor
    }))), /*#__PURE__*/_react.default.createElement(_Layout.Container, null, /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
      justifyContent: "center"
    }, /*#__PURE__*/_react.default.createElement(_Hero.HeroColumn, {
      backgroundColor: defaults.background,
      width: defaults.widths,
      variant: variant
    }, /*#__PURE__*/_react.default.createElement(_Hero.HeroHeadline, {
      size: hero.titleSize,
      textColor: textColor,
      variant: variant
    }, title), subTitle && /*#__PURE__*/_react.default.createElement(_Hero.HeroSubTitle, {
      mt: 2,
      size: hero.subtitleSize,
      textColor: textColor,
      variant: variant
    }, subTitle), cta && /*#__PURE__*/_react.default.createElement(_Hero.HeroButton, Object.assign({
      variant: hero.buttonVariant,
      inverted: hero.buttonInverted,
      mt: [2, 3, 4, 5]
    }, cta), cta.label))))));
  }

  return /*#__PURE__*/_react.default.createElement(_Hero.Wrapper, Object.assign({
    variant: variant
  }, wrapperProps), /*#__PURE__*/_react.default.createElement(_Hero.Overlay, null, banner && /*#__PURE__*/_react.default.createElement(_Hero.HeroBanner, null, /*#__PURE__*/_react.default.createElement(_Banner.default, Object.assign({}, banner, {
    textColor: hero.bannerTextColor
  }))), /*#__PURE__*/_react.default.createElement(_Layout.Container, null, /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_Hero.HeroColumn, {
    backgroundColor: defaults.background,
    width: defaults.widths,
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_Hero.HeroHeadline, {
    size: hero.titleSize,
    textColor: textColor,
    variant: variant
  }, title), subTitle && /*#__PURE__*/_react.default.createElement(_Hero.HeroSubTitle, {
    mt: 2,
    size: hero.subtitleSize,
    textColor: textColor,
    variant: variant
  }, subTitle), cta && /*#__PURE__*/_react.default.createElement(_Hero.HeroButton, Object.assign({
    variant: hero.buttonVariant,
    inverted: hero.buttonInverted,
    mt: [2, 3, 4, 5]
  }, cta), cta.label))))));
};

HeroRegular.propTypes = {
  /** Hero variant */
  variant: _propTypes.default.oneOf(['standard', 'large']),

  /** Text color for title and subtitle */
  textColor: _propTypes.default.oneOf(['standard', 'inverted']),

  /** Hero title */
  title: _propTypes.default.string,

  /** Hero body copy */
  subTitle: _propTypes.default.string,

  /** Hero call to action  */
  cta: _propTypes.default.shape({
    /** Hero call to action label */
    label: _propTypes.default.string,

    /** Hero call to action URL */
    url: _propTypes.default.string
  }),
  banner: _propTypes.default.shape({
    image: _propTypes.default.shape({
      src: _propTypes.default.string,
      fluid: _propTypes.default.shape({}),
      fixed: _propTypes.default.shape({})
    }),
    label: _propTypes.default.string
  }),
  hero: _propTypes.default.shape({
    bannerTextColor: _propTypes.default.string,
    buttonInverted: _propTypes.default.bool,
    buttonVariant: _propTypes.default.string,
    heroLargeColumnWidth: _propTypes.default.arrayOf(_propTypes.default.number),
    titleSize: _propTypes.default.string,
    subtitleSize: _propTypes.default.string
  }),
  wrapperProps: _propTypes.default.shape({
    mediaType: _propTypes.default.string
  })
};
HeroRegular.defaultProps = {
  banner: null,
  cta: null,
  subTitle: null,
  textColor: 'standard',
  title: null,
  variant: 'standard',
  hero: {},
  wrapperProps: null
};
var _default = HeroRegular;
exports.default = _default;